"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggeredSegment = void 0;
const building_blocks_ui_acko_analytics_1 = require("@acko-tech/building-blocks.ui.acko-analytics");
const triggeredSegment = (eventName, data) => {
    return (0, building_blocks_ui_acko_analytics_1.trackEvent)(eventName, Object.assign({}, data));
};
exports.triggeredSegment = triggeredSegment;
//# sourceMappingURL=segments.js.map